import { Component, ViewChild, ElementRef, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { LocalsService } from '../locals.service';

@Component({
  selector: 'app-view-local-profile',
  templateUrl: './view-local-profile.component.html',
  styleUrls: ['./view-local-profile.component.css']
})
export class ViewLocalProfileComponent implements OnChanges {
  @ViewChild('modal', { static: false }) modal: ElementRef;
  @ViewChild('closeAddExpenseModal', { static: false })
  closeAddExpenseModal: ElementRef;
  @Input() Local;
  local: any;
  constructor(private localsApi: LocalsService, private router: Router) {}
  ngOnChanges() {
    // this.local=new Local()
    this.local = this.Local;
  }
}
